import { mapState, mapGetters } from 'vuex'
import swal from 'sweetalert2'

// TODO - add $ to all methods to specify global function

const mixins = {
  computed: {
    ...mapState('auth', ['currentUser']),
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters('responsive', ['screenSize', 'allowParallax'])
  },
  methods: {
    slugify: string => {
      return string
        .toString()
        .toLowerCase()
        .trim()
        .replace(/&/g, '-and-') // Replace & with 'and'
        .replace(/[\s\W-]+/g, '-') // Replace spaces, non-word characters and dashes with a single dash (-)
        .replace(/-$/, '') // Remove last floating dash if exists
    },
    truncateString: (string, maxChars = 15) => {
      if (string === undefined) {
        return ''
      }

      if (string.length > maxChars) {
        return string.substring(0, maxChars) + '...'
      } else {
        return string
      }
    },
    stripHTML: html => {
      let tempDivElement = document.createElement('div')

      tempDivElement.innerHTML = html

      return tempDivElement.textContent || tempDivElement.innerText || ''
    },
    parseBoolean: value => {
      // this method is used to parse Boolean since from strings from database. ex. '0' should be false
      if (value === undefined || value === null) {
        return false
      } else {
        return Boolean(JSON.parse(value))
      }
    },
    loadMedia: (imagePath, imageSize = null) => {
      if (imagePath && imageSize) {
        let imagePathWithSize = imagePath
          .replace('/storage/media/', '/storage/thumbnails/')
          .replace(/(\.[\w\d_-]+)$/i, '_' + imageSize + '$1')
        return imagePathWithSize
      }

      return imagePath
    },
    fieldCategories(fields) {
      return Array.from(
        new Set(
          Object.values(fields)
            .filter(field => field.category)
            .map(field => field.category)
        )
      )
    },
    getFieldsByCategory(fields, category = undefined) {
      return Object.fromEntries(
        Object.entries(fields).filter(
          ([key, value]) => value.category == category
        )
      )
    },
    calculateColumnContainerSize: size => {
      switch (size) {
        case 'xl':
          return {
            cols: '12'
          }
        case 'lg':
          return {
            cols: '12',
            sm: '10'
          }
        case 'md':
          return {
            cols: '12',
            sm: '8',
            md: '6'
          }
        case 'sm':
          return {
            cols: '12',
            sm: '8',
            md: '6',
            lg: '4'
          }
        case 'xs':
          return {
            cols: '12',
            sm: '8',
            md: '4',
            lg: '3'
          }
        default:
          return {
            cols: '12'
          }
      }
    },
    calculateColumns: columns => {
      switch (columns) {
        case '6':
          return {
            cols: '12',
            sm: '4',
            md: '4',
            lg: 12 / columns,
            xl: 12 / columns
          }
        case '4':
          return {
            cols: '12',
            sm: '6',
            md: '6',
            lg: 12 / columns,
            xl: 12 / columns
          }
        case '3':
          return {
            cols: '12',
            sm: 12 / columns,
            md: 12 / columns,
            lg: 12 / columns,
            xl: 12 / columns
          }
        case '2':
          return {
            cols: '12',
            sm: 12 / columns,
            md: 12 / columns,
            lg: 12 / columns,
            xl: 12 / columns
          }
        case '1':
          return {
            cols: '12'
          }
        default:
          return {
            cols: '12'
          }
      }
    },
    handleGraphQLSuccess: (
      message,
      htmlMessage = false,
      timer = 3000,
      type = 'success'
    ) => {
      swal({
        title: htmlMessage ? null : message,
        toast: true,
        html: htmlMessage ? message : null,
        type: type,
        position: 'top',
        timer: timer,
        showConfirmButton: false
      })
    },
    handleGraphQLErrors: error => {
      let { graphQLErrors } = error
      console.log(error)

      if (graphQLErrors[0].extensions.category === 'validation') {
        let errorHTML = ''

        Object.values(graphQLErrors[0].extensions.validation).forEach(value => {
          errorHTML += `<span>${value[0].replace('data.', '')}</span><br />`
        })

        swal({
          title: 'Validation failed.',
          toast: true,
          html: errorHTML,
          type: 'error',
          position: 'top',
          timer: 3000,
          showConfirmButton: false
        })
      } else if (
        graphQLErrors[0].extensions.category == 'graphql' &&
        graphQLErrors[0].message
      ) {
        swal({
          title: graphQLErrors[0].message,
          toast: true,
          type: 'error',
          position: 'top',
          timer: 3000,
          showConfirmButton: false
        })
      } else if (graphQLErrors[0].extensions.category == 'authorization') {
        swal({
          title: 'You are not authorized to make this action.',
          toast: true,
          type: 'error',
          position: 'top',
          timer: 3000,
          showConfirmButton: false
        })
      } else {
        swal({
          title: 'Something went wrong.',
          toast: true,
          text: 'Please make sure that all fields are filled up correctly.',
          type: 'error',
          position: 'top',
          timer: 3000,
          showConfirmButton: false
        })
      }
    }
  }
}

export default mixins
